export default __webpack_public_path__ + "static/media/material-ui.da7fba49.svg";